{
    angular
        .module("utilsModule")
        .factory("utils.common", common);
    common.$inject = ['alertControl' ,'$timeout'];
    function common(alertControl,$timeout) {
        let loading=null;
        // let alertView;
        let collect={
            'alert':alert,
            'prompt':prompt,
            'loading':{
                'show':showLoading,
                'hide':hideLoading
            }
        }

        function alert( title,content,buttons) {
            let btns=buttons;
            let alert=null;
            if(!btns||typeof(btns)=='undefined'||btns.length==0){
                btns=[{
                    'title':'确定',
                    'action':function(){
                        alert.close();
                    }
                }];
            }
            alert=alertControl.show(title,content,btns);
            return alert;
        }
        function prompt(content){
            let prompt=alertControl.show(null,content);
            $timeout(function () {
                prompt.close();
            }, 1500);
            
        }
        function showLoading(content){
            if(!loading){
                // console.log('请稍候一会儿...');
                loading=alertControl.show(null,content||'请稍候一会儿...');
            }
        }
        function hideLoading(content){
            if(loading){
                loading.close();
            }
            loading=null;
        }
        return collect;
    }
}